export default __webpack_public_path__ + "static/media/player_3.5962e22d.png";